module.exports = __webpack_public_path__ + "static/media/leaderboard-un-active.65975aa9.svg";